import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetCategoriesDocument,
  type GetCategoriesQuery,
  type GetCategoriesQueryVariables,
} from "~/features/admin/categories/gqls";

/**
 * Categories filtered by typeId, deactivated rows hidden. Used by the tree
 * tabs (which need the full set scoped to entity or relation).
 */
export function useCategoryListByType(typeId: "entity" | "relation") {
  return useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, {
    variables: {
      where: {
        typeId: { _eq: typeId },
        deactivatedAt: { _isNull: true },
      },
    },
  });
}
